import { addError } from "../stores/LoggerStore";
export default class Path {
    constructor(path) {
        this.setPath(path);
        return this;
    }
    get isEmpty() {
        return this.path === "";
    }
    get isHome() {
        return this.path === "~";
    }
    // assumes that all paths begin with '~/', which is home
    // removes '.' and '..'
    static calcNetPath(path) {
        const paths = path.split(Path.splitter);
        if (!paths.at(0) || paths.at(0) === ".." || paths.at(0).length === 0) {
            addError("First argument of path cannot be (..) nor empty @Commands.calcNetPath");
            return undefined;
        }
        if (!paths.includes("..") || paths.length === 1) {
            return path;
        }
        for (let i = 1; i < paths.length; ++i) {
            const val = paths.at(i);
            if (val !== "..") {
                continue;
            }
            delete paths[i];
            if (paths[i - 1] !== "~") {
                delete paths[i - 1];
            }
            break;
        }
        return Path.calcNetPath(Path.refine(paths.join(Path.splitter)));
    }
    static refine(path) {
        return path === null || path === void 0 ? void 0 : path.trim().split(Path.splitter).filter((val) => val !== "" && val !== " " && val !== "/").map((path) => path.trim()).join(Path.splitter);
    }
    static join(l, r) {
        if (!l || !l.length)
            return new Path(r);
        if (!r || !r.length)
            return new Path(l);
        return new Path(Path.refine(l) + Path.splitter + Path.refine(r));
    }
    setPath(path) {
        let refinedPrimary = Path.refine(path);
        if (!refinedPrimary) {
            this.path = "";
            return;
        }
        refinedPrimary = refinedPrimary
            .split(Path.splitter)
            .filter((node) => node !== ".")
            .join(Path.splitter);
        this.path = Path.calcNetPath(refinedPrimary);
        this.paths = this.path.split(Path.splitter);
        this.last = this.paths.at(this.paths.length - 1);
        this.parentArray = this.paths.slice(0, this.paths.length - 1);
        this.parent = this.paths
            .slice(0, this.paths.length - 1)
            .join(Path.splitter);
    }
    // does not include '~/'
    get subPaths() {
        const subPaths = [];
        //calc subpaths
        for (let i = 0; i < this.paths.length; ++i) {
            subPaths.push(new Path(this.paths.slice(0, i + 1).join(Path.splitter)));
        }
        return subPaths;
    }
    get extension() {
        const lastIndex = this.last.lastIndexOf(".");
        if (lastIndex === -1) {
            return "";
        }
        return this.last.slice(lastIndex + 1);
    }
    isSame(rhs) {
        return this.path === rhs.path;
    }
    copied() {
        return new Path(this.path);
    }
    startsWith(rhs) {
        return this.path.startsWith(rhs.path);
    }
}
Path.splitter = "/";
